import { ResponsiveValue, Text } from '@chakra-ui/react';
import { PencilIcon } from '@diamond/shared/icons';
import { Button } from '@diamond/shared/ui';

interface CartItemNoteToggleProps {
  isDisabled: boolean;
  onToggle: () => void;
  display?: ResponsiveValue<'flex' | 'none'>;
  note?: string | null;
}

export const CartItemNoteToggle = ({
  isDisabled,
  onToggle,
  display = { base: 'none', lg: 'flex' },
  note,
}: CartItemNoteToggleProps) => {
  if (isDisabled) {
    return null;
  }

  const hasNote = !!note;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onToggle();
  };

  return (
    <Button
      display={display}
      variant="link"
      color={hasNote ? 'gray.75' : 'blue'}
      fontWeight="normal"
      onClick={handleClick}
      fontSize={{ base: '12px', lg: '14px' }}
      p={0}
      h="auto"
      maxW="100%"
      justifyContent="flex-start"
      textAlign="left"
      gap="2px"
      textDecoration="none"
      _hover={{ textDecoration: 'none' }}
      _active={{ textDecoration: 'none' }}
    >
      {!hasNote ? <PencilIcon size={14} style={{ flexShrink: 0 }} /> : null}
      <Text
        ml="2px"
        fontSize={{ base: '12px', lg: '14px' }}
        noOfLines={2}
        wordBreak="break-word"
      >
        {hasNote ? note : 'Tulis Catatan'}
      </Text>
      {hasNote ? <PencilIcon size={14} style={{ flexShrink: 0 }} /> : null}
    </Button>
  );
};
